import type { ReactElement } from 'react'

import { FormattedMessage, useIntl } from 'react-intl'
import { styled } from 'styled-components'

import { Colors } from '@b-stock/fe-core/design-system'

import type { CardOrderItem } from '@/buyer-portal/components/CardOrder'
import { CardOrder } from '@/buyer-portal/components/CardOrder'

const PaymentMethodContainer = styled.div`
  margin-top: 0.75rem;
`

const PaymentMethodButton = styled.button`
  background: none;
  border: none;
  color: ${Colors.Semantic.BStock.default.lightBackground};
  cursor: pointer;
  padding: 0;
  text-align: right;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: 0.125rem solid ${Colors.Semantic.BStock.default.lightBackground};
    outline-offset: 0.125rem;
  }
`

export type AutoPaymentMethodSelectorProps = {
  onPaymentMethodClick: () => void
  autoPayMethodLabel?: ReactElement
}

const ns = 'BidConfirmationModal.autoPay.paySection'

export const AutoPaymentMethodSelector = ({
  onPaymentMethodClick,
  autoPayMethodLabel,
}: AutoPaymentMethodSelectorProps) => {
  const { formatMessage } = useIntl()

  const methodLabel: ReactElement = autoPayMethodLabel ?? (
    <FormattedMessage id="BidConfirmationModal.autoPay.modal.paymentMethods.netTerms.label" />
  )

  const cardOrderData: CardOrderItem[] = [
    {
      title: formatMessage({ id: `${ns}.label` }),
      value: (
        <PaymentMethodButton
          onClick={onPaymentMethodClick}
          data-testid="auto-payment-method-button"
          type="button"
          aria-label={formatMessage({ id: `${ns}.payMethodButton.ariaLabel` })}
        >
          {methodLabel}
        </PaymentMethodButton>
      ),
    },
  ]

  return (
    <PaymentMethodContainer data-testid="auto-payment-method-action-container">
      <CardOrder data={cardOrderData} level={1} />
    </PaymentMethodContainer>
  )
}
